import React from 'react';

import { Modal } from 'rsuite';

import './Soon.css';

function useOutsideAlerter(ref, setShow) {
    React.useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setShow(false);
            }
        }
        
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref, setShow]);
}

function Soon(props) {

    const [show, setShow] = React.useState(false);
    const backdrop = true;

    const change = () => {
        console.log(show);
	setShow(!show);
    }

    const wrapperRef = React.useRef(null);
    useOutsideAlerter(wrapperRef, setShow);

    return(
	<React.Fragment>
            <div onClick={() => change()} className="ghost-header-button">{props.text}</div>

	    <Modal onHide={change} show={show} backdrop={backdrop} >
	
	    	<div ref={wrapperRef} className="ghost-modal-soon">
	    	    <div className="ghost-modal-soon-title">
	    		<span id="C">c</span>
	    		<span id="O2">o</span>
	    		<span id="M">m</span>
	    		<span id="I">i</span>
	    		<span id="N">n</span>
	    		<span id="G">g</span>
	    		<span>&nbsp;</span>
	    		<span id="S">s</span>
	    		<span id="O5">o</span>
	    		<span id="O6">o</span>
	    		<span id="N7">n</span>
	    	    </div>
	    	    
	            <div className="ghost-modal-soon-citation">
	    	    	"The <span className="ghost-glitch-words-other">ones who</span> are <span className="ghost-glitch-word">crazy</span> enough to think that they can <span className="ghost-glitch-words">change</span> the <span className="ghost-glitch-words">world</span> are the ones who do."
	    	    </div>

	            <div className="ghost-modal-soon-name">
	    		<span className="ghost-glitch">
	    	            <span ariaHidden={true}>John McAfee</span>
	    	            John McAfee
	    	            <span ariaHidden={true}>John McAfee</span>
	                </span>
                    </div>

	    	</div>

	    </Modal>
	</React.Fragment>
    );
}

export default Soon;
